import React, { useState, useEffect } from 'react';
import { Button, Card, Row, Col } from 'react-bootstrap';
import { FaArrowDown, FaArrowUp, FaTimes, FaHistory } from 'react-icons/fa';

const TransactionNotification = ({ show, onHide, transaction, onViewStatement }) => {
  const [visible, setVisible] = useState(show);

  useEffect(() => {
    setVisible(show);
    
    // Auto-hide after 10 seconds
    if (show) {
      const timer = setTimeout(() => {
        setVisible(false);
        if (onHide) onHide();
      }, 10000);
      
      return () => clearTimeout(timer);
    }
  }, [show, onHide]);

  if (!visible || !transaction) return null;

  const isCredit = transaction.type === 'credit';
  const isSuccess = transaction.status === 'success';
  const isFailed = transaction.status === 'failed';
  const isPending = transaction.status === 'pending';

  const getStatusColor = () => {
    if (isSuccess) return isCredit ? 'success' : 'info';
    if (isFailed) return 'danger';
    if (isPending) return 'warning';
    return 'secondary';
  };

  const getStatusIcon = () => {
    if (isSuccess) return isCredit ? <FaArrowUp /> : <FaArrowDown />;
    if (isFailed) return <FaTimes />;
    if (isPending) return '⏳';
    return '❓';
  };

  const getStatusText = () => {
    if (isSuccess) return isCredit ? 'Money Added Successfully!' : 'Money Deducted Successfully!';
    if (isFailed) return 'Transaction Failed';
    if (isPending) return 'Transaction Pending';
    return 'Transaction Updated';
  };

  const getAmountColor = () => {
    if (isCredit) return 'text-success';
    if (isFailed) return 'text-muted';
    return 'text-danger';
  };

  const getAmountPrefix = () => {
    if (isCredit) return '+';
    if (isFailed) return '';
    return '-';
  };

  return (
    <div className="position-fixed" style={{ top: '20px', right: '20px', zIndex: 9999, minWidth: '350px' }}>
      <Card className={`border-${getStatusColor()} shadow-lg`}>
        <Card.Body className="p-3">
          <div className="d-flex justify-content-between align-items-start mb-2">
            <div className="d-flex align-items-center">
              <div className={`me-2 text-${getStatusColor()}`}>
                {getStatusIcon()}
              </div>
              <div>
                <h6 className="mb-0 fw-bold">{getStatusText()}</h6>
                <small className="text-muted">{transaction.formatted_date}</small>
              </div>
            </div>
            <Button
              variant="link"
              size="sm"
              className="p-0 text-muted"
              onClick={() => {
                setVisible(false);
                if (onHide) onHide();
              }}
            >
              <FaTimes />
            </Button>
          </div>

          <div className="mb-3">
            <div className="d-flex justify-content-between align-items-center">
              <span className="fw-bold">Amount:</span>
              <span className={`fw-bold fs-5 ${getAmountColor()}`}>
                {getAmountPrefix()}{transaction.formatted_amount}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="text-muted">Description:</span>
              <span className="text-end">{transaction.note}</span>
            </div>
            {transaction.external_ref && (
              <div className="d-flex justify-content-between align-items-center">
                <span className="text-muted">Reference:</span>
                <span className="text-end small">{transaction.external_ref}</span>
              </div>
            )}
          </div>

          <Row className="g-2">
            <Col>
              <Button
                variant="outline-primary"
                size="sm"
                className="w-100"
                onClick={() => {
                  if (onViewStatement) onViewStatement();
                  setVisible(false);
                  if (onHide) onHide();
                }}
              >
                <FaHistory className="me-1" />
                View Statement
              </Button>
            </Col>
            <Col>
              <Button
                variant="outline-secondary"
                size="sm"
                className="w-100"
                onClick={() => {
                  setVisible(false);
                  if (onHide) onHide();
                }}
              >
                Close
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
};

export default TransactionNotification;

